import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceTrainingObjectiveTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupTrainingObjective = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceTrainingObjectiveTypes.TrainingObjectiveLookupDataType): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (search) {
    query.search = search.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.trainingObjective.lookupTrainingObjective), {
    blockSpinner,
  });
};

export const lookupTrainingObjectiveTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceTrainingObjectiveTypes.TrainingObjectiveLookupDataType): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(
      urlHelper.addQueryParameters({ search: value }, urlsConfig.trainingObjective.lookupTrainingObjective),
      {
        blockSpinner,
      },
    );
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.trainingObjective.lookupTrainingObjective), {
    blockSpinner,
  });
};

export const createTrainingObjective = (
  form: serviceTrainingObjectiveTypes.TrainingObjectiveCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveCreateResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const procesesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.trainingObjectiveNumber) {
    formData.append('trainingObjectiveNumber', form.trainingObjectiveNumber);
  }

  if (form.trainingObjective) {
    formData.append('trainingObjective', form.trainingObjective);
  }

  if (form.creationDate) {
    formData.append('creationDate', form.creationDate.toString());
  }

  if (form.modificationDate) {
    formData.append('modificationDate', form.modificationDate.toString());
  }

  if (form.relatedStandards) {
    formData.append('relatedStandards', form.relatedStandards);
  }

  if (form.relatedAudienceEntities) {
    formData.append('relatedAudienceEntities', form.relatedAudienceEntities.join(','));
  }

  if (form.relatedAudienceProcesses) {
    formData.append('relatedAudienceProcesses', form.relatedAudienceProcesses.join(','));

    // formData.append('relatedAudienceProcesses', procesesData);
  }
  if (form.objectiveTypeId) {
    formData.append('objectiveTypeId', form.objectiveTypeId);
  }

  if (form.scenarioConditions) {
    formData.append('scenarioConditions', form.scenarioConditions);
  }

  if (form.scenarioConditionStatus) {
    formData.append('scenarioConditionStatus', form.scenarioConditionStatus);
  }

  if (form.milConditions) {
    formData.append('milConditions', form.milConditions);
  }

  if (form.milConditionStatus) {
    formData.append('milConditionStatus', form.milConditionStatus);
  }

  if (form.observerTrainerConditions) {
    formData.append('observerTrainerConditions', form.observerTrainerConditions);
  }

  if (form.observerTrainerConditionStatus) {
    formData.append('observerTrainerConditionStatus', form.observerTrainerConditionStatus);
  }

  if (form.battleRhythmConditions) {
    formData.append('battleRhythmConditions', form.battleRhythmConditions);
  }

  if (form.battleRhythmConditionStatus) {
    formData.append('battleRhythmConditionStatus', form.battleRhythmConditionStatus);
  }

  if (form.exerciseControlConditions) {
    formData.append('exerciseControlConditions', form.exerciseControlConditions);
  }

  if (form.exerciseControlConditionStatus) {
    formData.append('exerciseControlConditionStatus', form.exerciseControlConditionStatus);
  }

  if (form.trainingAudienceConditions) {
    formData.append('trainingAudienceConditions', form.trainingAudienceConditions);
  }

  if (form.trainingAudienceConditionStatus) {
    formData.append('trainingAudienceConditionStatus', form.trainingAudienceConditionStatus);
  }

  if (form.cisConditions) {
    formData.append('cisConditions', form.cisConditions);
  }

  if (form.cisConditionStatus) {
    formData.append('cisConditionStatus', form.cisConditionStatus);
  }

  if (form.simulationConditions) {
    formData.append('simulationConditions', form.simulationConditions);
  }

  if (form.simulationConditionStatus) {
    formData.append('simulationConditionStatus', form.simulationConditionStatus);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.subtasks) {
    formData.append('subtasks', form.subtasks);
  } else {
    formData.append('subtasks', '');
  }

  if (form.log) {
    formData.append('log', form.log);
  }
  if (form.deducedFromObjectiveId) {
    formData.append('deducedFromObjectiveId', form.deducedFromObjectiveId);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.trainingObjectiveStatusId) {
    formData.append('trainingObjectiveStatusId', form.trainingObjectiveStatusId);
  }

  return axios.post(urlsConfig.trainingObjective.createTrainingObjective, formData, { blockErrorHandler: true });
};

export const trainingObjectiveEdit = (
  form: serviceTrainingObjectiveTypes.TrainingObjectiveEditDataType,
  // formData: FormData,
): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveEditResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const procesesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }
  // TODO swicth case ile kontrol sağlayabilirsin.

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.trainingObjectiveNumber) {
    formData.append('trainingObjectiveNumber', form.trainingObjectiveNumber);
  }

  if (form.trainingObjective) {
    formData.append('trainingObjective', form.trainingObjective);
  }

  if (form.creationDate) {
    formData.append('creationDate', form.creationDate.toString());
  }

  if (form.modificationDate) {
    formData.append('modificationDate', form.modificationDate.toString());
  }

  if (form.relatedStandards) {
    formData.append('relatedStandards', form.relatedStandards);
  }

  if (form.relatedAudienceEntities) {
    formData.append('relatedAudienceEntities', form.relatedAudienceEntities.join(','));
  }

  if (form.relatedAudienceProcesses) {
    formData.append('relatedAudienceProcesses', form.relatedAudienceProcesses.join(','));

    // formData.append('relatedAudienceProcesses', procesesData);
  }
  if (form.objectiveTypeId) {
    formData.append('objectiveTypeId', form.objectiveTypeId);
  }

  if (form.scenarioConditions) {
    formData.append('scenarioConditions', form.scenarioConditions);
  }

  if (form.scenarioConditionStatus) {
    formData.append('scenarioConditionStatus', form.scenarioConditionStatus);
  }

  if (form.milConditions) {
    formData.append('milConditions', form.milConditions);
  }

  if (form.milConditionStatus) {
    formData.append('milConditionStatus', form.milConditionStatus);
  }

  if (form.observerTrainerConditions) {
    formData.append('observerTrainerConditions', form.observerTrainerConditions);
  }

  if (form.observerTrainerConditionStatus) {
    formData.append('observerTrainerConditionStatus', form.observerTrainerConditionStatus);
  }

  if (form.battleRhythmConditions) {
    formData.append('battleRhythmConditions', form.battleRhythmConditions);
  }

  if (form.battleRhythmConditionStatus) {
    formData.append('battleRhythmConditionStatus', form.battleRhythmConditionStatus);
  }

  if (form.exerciseControlConditions) {
    formData.append('exerciseControlConditions', form.exerciseControlConditions);
  }

  if (form.exerciseControlConditionStatus) {
    formData.append('exerciseControlConditionStatus', form.exerciseControlConditionStatus);
  }

  if (form.trainingAudienceConditions) {
    formData.append('trainingAudienceConditions', form.trainingAudienceConditions);
  }

  if (form.trainingAudienceConditionStatus) {
    formData.append('trainingAudienceConditionStatus', form.trainingAudienceConditionStatus);
  }

  if (form.cisConditions) {
    formData.append('cisConditions', form.cisConditions);
  }

  if (form.cisConditionStatus) {
    formData.append('cisConditionStatus', form.cisConditionStatus);
  }

  if (form.simulationConditions) {
    formData.append('simulationConditions', form.simulationConditions);
  }

  if (form.simulationConditionStatus) {
    formData.append('simulationConditionStatus', form.simulationConditionStatus);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.subtasks) {
    formData.append('subtasks', form.subtasks);
  } else {
    formData.append('subtasks', '');
  }

  if (form.log) {
    formData.append('log', form.log);
  }
  if (form.deducedFromObjectiveId) {
    formData.append('deducedFromObjectiveId', form.deducedFromObjectiveId);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.trainingObjectiveStatusId) {
    formData.append('trainingObjectiveStatusId', form.trainingObjectiveStatusId);
  }

  return axios.patch(urlsConfig.trainingObjective.trainingObjectiveEdit, formData, { blockErrorHandler: true });
};

export const trainingObjectiveDelete = ({
  id,
}: serviceTrainingObjectiveTypes.TrainingObjectiveDeleteDataType): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveDeleteResultType> => {
  return axios.delete(`${urlsConfig.trainingObjective.trainingObjectiveDelete}/${id}`);
};

export const trainingObjectiveIncidentChartReport = (
  form: serviceTrainingObjectiveTypes.TrainingObjectiveIncidentChartDataType,
): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveIncidentChartResultType[]> => {
  return axios.post(urlsConfig.trainingObjective.trainingObjectiveIncidentChart, form, { blockErrorHandler: true });
};

export const trainingObjectiveEditOverwrite = ({
  id,
  objectiveOverwrittenValue,
}: serviceTrainingObjectiveTypes.TrainingObjectiveEditOverwriteDataType): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveEditOverwriteResultType> => {
  return axios.patch(urlsConfig.trainingObjective.trainingObjectiveEditOverwrite, {
    id,
    objectiveOverwrittenValue,
  });
};
